import {Component, OnInit} from '@angular/core';
import {FirebaseService} from "../../../../../../service/firebase/firebase.service";
import {take} from "rxjs/operators";
import {UvIndexVorhersage} from "../../../../../../model/vorhersagen/vorhersage-uv-index";
import {DateUtil} from "../../../../../../util/date-util";
import {BundeslandFilterService} from "../../../../../../service/bundeslandFilter/bundesland-filter.service";
import {Bundesland} from "../../../../../../model/component/bundesland";
import {SearchFilterService} from "../../../../../../service/search/search-filter.service";
import {MatTabChangeEvent} from "@angular/material/tabs";

@Component({
  selector: 'app-uv-index',
  templateUrl: './uv-index.component.html',
  styleUrls: ['./uv-index.component.css']
})
export class UvIndexComponent implements OnInit {

  selectedIndex: number = 0;
  selectedBundesland: string;
  uvIndexVorhersage: UvIndexVorhersage[];

  constructor(private searchFilterService: SearchFilterService, private firebaseService: FirebaseService, public bundeslandFilterService: BundeslandFilterService) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
    this.bundeslandFilterService.onFilterUpdated.subscribe((bundeslaender: Array<Bundesland>) => {
      this.loadData();
    });

    this.searchFilterService.onUvIndexSearchFilterUpdated.subscribe((filterValue: string) => {
      if (filterValue.length === 0) {
        this.loadData();
      } else {
        this.uvIndexVorhersage = this.uvIndexVorhersage.filter(vorhersage => vorhersage.ort.name.toLowerCase().includes(filterValue));
      }
    });

  }

  onTabChange($event: MatTabChangeEvent) {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = 0;
  }

  ngOnInit() {this.loadData();}

  private loadData() {
    this.uvIndexVorhersage = [];
    this.firebaseService
      .getUvIndexDeutschland(this.bundeslandFilterService.getSelectedBundeslaenderNamesWithSimpleNameForBremen())
      .pipe(take(1))
      .subscribe(querySnapshot => {
        querySnapshot.docs.map(doc => {
          this.uvIndexVorhersage.push(doc.data());
          this.createListen();
        })
      }, error => console.log(error));
  }

  private createListen() {
    for (let uv of this.uvIndexVorhersage) {
      uv.vorhersagen.tagesListe = [uv.vorhersagen.tag00, uv.vorhersagen.tag01, uv.vorhersagen.tag02];
      let dayCount = 0;
      for (let tag of uv.vorhersagen.tagesListe) {
        let skinTypes = tag.skintypesMaxExposureDurations;
        skinTypes.hautTypListe = [skinTypes.hautTyp1, skinTypes.hautTyp2, skinTypes.hautTyp3, skinTypes.hautTyp4, skinTypes.hautTyp5, skinTypes.hautTyp6];
        tag.datum = DateUtil.addDays(uv.forecastDay.toDate(), dayCount);
        dayCount++;
      }
    }
  }
}
